import { useEffect, useMemo } from 'react';
import { useAppConfiguration, useGraphqlQuery } from '@mews-commander/data-access';
import { graphql } from '@mews-commander/guest-profile';

export const GuestTotalStaysByIds = graphql(`
    query GuestTotalStaysByIdsResult($guestIds: [UUID!]!) {
        guestSummaryByIds(guestIds: $guestIds) {
            guestId
            analytics {
                totalStays
            }
        }
    }
`);

export const useGuestTotalStaysByIds = (guestIds: string[], timeoutInMilliseconds = 5000) => {
    const { guestProfileApiUrl } = useAppConfiguration();
    const controller = useMemo(() => new AbortController(), []);

    useEffect(() => {
        const timeout = window.setTimeout(() => controller.abort(), timeoutInMilliseconds);
        return () => {
            window.clearTimeout(timeout);
            controller.abort();
        };
    }, [timeoutInMilliseconds, controller]);

    return useGraphqlQuery(
        guestProfileApiUrl,
        {
            document: GuestTotalStaysByIds,
            variables: { guestIds },
            signal: controller.signal,
        },
        { enabled: !!guestIds?.length, staleTime: 0, retry: false }
    );
};
